import { render } from "./book-header.vue?vue&type=template&id=27e70d3f&scoped=true"
const script = {}

import "./book-header.vue?vue&type=style&index=0&id=27e70d3f&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e70d3f"]])

export default __exports__